import {Component, OnInit} from '@angular/core';
import {StateService} from "@uirouter/core";

import {ParametersService, SubtitlesService, ZonesService} from "../../core";
import {ZoneViewData} from "../../models";

@Component({
    selector: 'time-limitation',
    templateUrl: './time-limitation.component.html',
    styleUrls: ['./time-limitation.component.scss']
})
export class TimeLimitationComponent implements OnInit {
    initZoneTimeHours: number = 0;
    initZoneTimeMinutes: number = 0;

    constructor(
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public zones: ZonesService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }
        this.checkSelectedZone();
        this.zones.setTime(this.zones.selectedZone['mode'].constTempTime);
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    disableButton(): boolean {
        if (this.initZoneTimeHours === 1 && this.initZoneTimeMinutes === 0) {
            return false;
        }
        return this.initZoneTimeHours === this.zones.time.hour
            && this.initZoneTimeMinutes === this.zones.time.minute;
    }

    checkSelectedZone() {
        const selectedZone = this.zones.selectedZone as ZoneViewData;
        const constantTempTime = selectedZone.mode.constTempTime;
        this.zones.setTime(constantTempTime);

        const zoneMode = selectedZone.mode.mode;
        let time: number = 0;
        if (constantTempTime === null) {
            time = 60;
        } else {
            time = constantTempTime === 0 && zoneMode === 'timeLimit' ? 1 : constantTempTime;
        }

        this.initZoneTimeHours = Math.floor(time / 60);
        this.initZoneTimeMinutes = time % 60
    }
}
